<template>
  <header>
    <nav>
      <!-- navbar logo -->
      <div class="xpress-logo">
        <router-link to="/home">
          <img :src="payoutLogo" alt="Payout Logo">
        </router-link>
      </div>
      <!-- navbar links -->
      <ul
        :class="['xpress-nav-lnk', activeSidebar?'sidebar-shown':'']"
      >
        <li>
          <router-link to="/home">Home</router-link>
        </li>
        <li>
          <a :href="aboutUrl">About</a>
        </li>
        <li>
          <a :href="contactUsUrl">Contact Us</a>
        </li>
        <li>
          <router-link to="/api/get-started">Docs</router-link>
        </li>
        <li v-if="user">
          <current-user-avatar />
        </li>
        <li v-else>
          <a @click.prevent="login" href="/login">Login</a>
        </li>
      </ul>
    </nav>
    <!--toggle button  -->
    <div class="xpress-sb-toggle-btn d-md-none">
      <div
        :class="['sb-nav-toggle', activeSidebar ? 'sb-is-active' : '']"
        @click="toggleSidebar"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </header>
</template>

<script>
import { ref } from '@vue/reactivity'
import { useStore } from 'vuex'
import 'bootstrap/dist/css/bootstrap.min.css'
import Logo from '../assets/logo.png'
import { computed } from '@vue/runtime-core'
import currentUserAvatar from './currentUserAvatar.vue'
import { getAboutUrl, getContactUsUrl, getStartedUrl } from '../utils/appConfig'

export default {
  components: { currentUserAvatar },
  name: 'Main Header',
  setup () {
    const store = useStore()

    const payoutLogo = ref(Logo)
    const activeSidebar = ref(false)
    const aboutUrl = ref(getAboutUrl())
    const contactUsUrl = ref(getContactUsUrl())
    const startedUrl = ref(getStartedUrl())
    const user = computed(() => store.getters['users/_user'])

    // methods
    const toggleSidebar = () => {
      activeSidebar.value = !activeSidebar.value
    }

    const login = () => store.dispatch('users/UserLogin')

    return {
      payoutLogo,
      activeSidebar,
      user,
      aboutUrl,
      contactUsUrl,
      startedUrl,
      toggleSidebar,
      login
    }
  }
}
</script>

<style lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  // --------------------------------

  header {
    width: 100%;
    height: fit-content;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-repeat: no-repeat;
    background-size: 890px auto;
    background-position: right -10px;

    &>nav {
      width: 100%;
      height: 101px;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      // navbar logo
      &>div.xpress-logo {
        width: 195px;
        height: 64px;
        display: flex;
        align-items: center;

        &>a {
          width: inherit;
          height: fit-content;
          display: inline-block;

          &>img {
            width: auto;
            height: auto;
          }
        }
      }
      // navbar links
      &>ul.xpress-nav-lnk {
        width: 700px;
        height: 44px;
        list-style-type: none;
        padding-left: 34.5px;
        padding-right: 34.5px;
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        transition: all 0.4s;

        &>li {
          width: fit-content;
          display: inline-flex;
          align-items: center;

          &:not(:last-child) {
            margin-right: 64px;
          }

          &>a {
            text-decoration: none;
            font-weight: normal;
            font-size: 20px;
            line-height: 24px;
            transition: all 0.4s;
            color: #000000;

            // active navigation
            &.router-link-exact-active {
              font-weight: 600;
            }

            // &:hover:not(.router-link-exact-active) {}
          }
        }
      }
    }
  }

  // MEDIA QUERY

  // XX-SM (<251px)
  @media (max-width: 250.9px) {
    header {
      align-items: center;
      position: sticky;
      top: 0;
      background-image: url(../assets/img/home/bg-home.png);

      &>nav {
        width: 70vw;
        height: 50px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        z-index: 10;

        // navbar logo
        &>div.xpress-logo {
          width: 100%;
          height: 100%;
          z-index: 2;

          &>a {
            width: 100%;
            height: fit-content;
            display: flex;
            align-items: flex-start;

            &>img {
              width: 90%;
              height: auto;
              margin-top: -5px;
            }
          }
        }
        // navbar links
        &>ul.xpress-nav-lnk {
          width: 100%;
          height: 100vh;
          position: fixed;
          left: -1000px;
          top: 0px;
          bottom: 0;
          padding-top: 60px;
          padding-left: 2%;
          padding-right: 2%;
          display: flex;
          flex-flow: column nowrap;
          justify-content: flex-start;
          align-items: flex-start;
          background-color: #ffffff;
          z-index: -1;

          &>li {
            width: 100%;
            display: block;
            padding: 7px 0;

            &:not(:last-child) {
              margin-right: 0;
            }

            &>a {
              width: fit-content;
              font-size: 15px;
              line-height: 24px;
            }
          }

          // sidebar on mobile devices
          &.sidebar-shown {
            left: 0;
          }
        }
      }
    }
  }
  // XX-SM
  @media (min-width: 251px) and (max-width: 350.9px) {
    header {
      align-items: center;
      position: sticky;
      top: 0;
      background-image: url(../assets/img/home/bg-home.png);

      &>nav {
        width: 70vw;
        height: 50px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        z-index: 10;

        // navbar logo
        &>div.xpress-logo {
          width: 100%;
          height: 100%;
          z-index: 2;

          &>a {
            width: 100%;
            height: fit-content;
            display: flex;
            align-items: flex-start;

            &>img {
              width: auto;
              height: auto;
            }
          }
        }
        // navbar links
        &>ul.xpress-nav-lnk {
          width: 100%;
          height: 100vh;
          position: fixed;
          left: -1000px;
          top: 0px;
          bottom: 0;
          padding-top: 60px;
          padding-left: 2%;
          padding-right: 2%;
          padding-bottom: 20px;
          display: flex;
          flex-flow: column nowrap;
          justify-content: flex-start;
          align-items: flex-start;
          background-color: #ffffff;
          z-index: -1;

          &>li {
            width: 100%;
            display: block;
            padding: 7px 0;

            &:not(:last-child) {
              margin-right: 0;
            }

            &>a {
              width: fit-content;
              font-size: 15px;
              line-height: 24px;
            }
          }

          // sidebar on mobile devices
          &.sidebar-shown {
            left: 0;
          }
        }
      }
    }
  }
  // X-SM
  @media (min-width: 351px) and (max-width: 575.9px) {
    header {
      align-items: center;
      position: sticky;
      top: 0;
      background-image: url(../assets/img/home/bg-home.png);

      &>nav {
        width: 70vw;
        height: 70px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        z-index: 10;

        // navbar logo
        &>div.xpress-logo {
          width: 70%;
          height: 100%;
          z-index: 2;

          &>a {
            width: 100%;
            height: fit-content;
            display: flex;
            align-items: flex-start;

            &>img {
              width: auto;
              height: auto;
              margin-top: 0px;
            }
          }
        }
        // navbar links
        &>ul.xpress-nav-lnk {
          width: 250px;
          height: 100vh;
          position: fixed;
          left: -1000px;
          top: 0px;
          bottom: 0;
          padding-top: 80px;
          padding-left: 3%;
          padding-right: 3%;
          padding-bottom: 20px;
          display: flex;
          flex-flow: column nowrap;
          justify-content: flex-start;
          align-items: flex-start;
          background-color: #ffffff;
          z-index: -1;

          &>li {
            width: 100%;
            display: block;
            padding: 7px 0;

            &:not(:last-child) {
              margin-right: 0;
            }

            &>a {
              width: fit-content;
              font-size: 17px;
              line-height: 24px;
            }
          }

          // sidebar on mobile devices
          &.sidebar-shown {
            left: 0;
          }
        }
      }
    }
  }
  // SM
  @media (min-width: 576px) and (max-width: 767.9px) {
    header {
      align-items: center;
      position: sticky;
      top: 0;
      background-image: url(../assets/img/home/bg-home.png);

      &>nav {
        width: 50vw;
        height: 90px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        z-index: 10;

        // navbar logo
        &>div.xpress-logo {
          width: 100%;
          height: 100%;
          z-index: 2;

          &>a {
            width: 100%;
            height: fit-content;
            display: flex;
            align-items: flex-start;

            &>img {
              width: auto;
              height: auto;
              margin-top: 0px;
            }
          }
        }
        // navbar links
        &>ul.xpress-nav-lnk {
          width: 300px;
          height: 100vh;
          position: fixed;
          left: -1000px;
          top: 0px;
          bottom: 0;
          padding-top: 100px;
          padding-left: 5%;
          padding-right: 5%;
          padding-bottom: 20px;
          display: flex;
          flex-flow: column nowrap;
          justify-content: flex-start;
          align-items: flex-start;
          background-color: #ffffff;
          z-index: -1;

          &>li {
            width: 100%;
            display: block;
            padding: 10px 0;

            &:not(:last-child) {
              margin-right: 0;
            }

            &>a {
              width: fit-content;
              // font-size: 17px;
              line-height: 24px;
            }
          }

          // sidebar on mobile devices
          &.sidebar-shown {
            left: 0;
          }
        }
      }
    }
  }
  // MD
  @media (min-width: 768px) and (max-width: 991.9px) {
    header {
      &>nav {
        height: 100px;

        // navbar logo
        // &>div.xpress-logo {}

        // navbar links
        &>ul.xpress-nav-lnk {
          // width: 400px;
          width: fit-content;
          padding: 0;

          &>li {
            &:not(:last-child) {
              margin-right: 25px;
            }

            &>a {
              font-size: 18px;

              // active navigation
              // &.router-link-exact-active {}

              // &:hover:not(.router-link-exact-active) {}
            }
          }
        }
      }
    }
  }
  // LG
  @media (min-width: 992px) and (max-width: 1200.9px) {
    header {
      &>nav {
        // navbar logo
        // &>div.xpress-logo {}

        // navbar links
        &>ul.xpress-nav-lnk {
          width: 600px;

          &>li {
            &:not(:last-child) {
              margin-right: 30px;
            }

            // &>a {}
          }
        }
      }
    }
  }
  // XL
  // @media (min-width: 1201px) {}
</style>
